/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2026-02-21 13:53:55.

export interface AdminLoginRequest {
  tenantKey: string;
  token: string;
}

export interface ConfigurationDTO {
  tenantKey: string;
  topXPlayersCanChallengeBetterPlayers: number;
  minChallengeRankType: string;
  defenderProtectionDurationMillis: number;
  challengerFreezeDurationMillis: number;
  instantRevengeBanDurationMillis: number;
  publicUrlParam: string;
  createdAt: Date;
}

export interface CreateGameRequest {
  challengerId: string;
  defenderId: string;
}

export interface CreatePlayerRequest {
  name: string;
}

export interface CreateTenantRequest {
  name: string;
  cupPassword: string;
  adminEmail: string;
  adminUid: string;
  adminPassword: string;
  startTimestamp: Date;
}

export interface FinishGameRequest {
  gameId: string;
  winnerId: string;
  result?: Nullable<string>;
}

export interface GameDTO {
  id: string;
  tenantKey: string;
  challenger: PlayerLiteDTO;
  defender: PlayerLiteDTO;
  challengeTimestamp: Date;
  winner?: Nullable<PlayerLiteDTO>;
  result?: Nullable<string>;
  gameResultTimestamp?: Nullable<Date>;
  gameDetails?: Nullable<GameDetailsDTO>;
}

export interface GameDetailsDTO {
  expectedStartTimestamp?: Nullable<Date>;
  location?: Nullable<string>;
  spectatorsAllowed?: Nullable<boolean>;
  additionalComments?: Nullable<string>;
}

export interface OperatorDataDTO {
  tenantData: OperatorTenantDTO[];
}

export interface OperatorTenantDTO {
  latestChallenge?: Nullable<Date>;
  latestResult?: Nullable<Date>;
  tenantName: string;
  tenantCreationDate: Date;
  totalChallenges: number;
  totalResults: number;
  challengesInLastThirtyDays: number;
  resultsInLastThirtyDays: number;
}

export interface PlayerDTO {
  id: string;
  name: string;
  ranking: number;
  challengeablePlayers: PlayerLiteDTO[];
  defenderProtectionDuration: number;
  challengerFreezeDuration: number;
  instantRevengeBanDuration: number;
  minPossibleDefenderRanking: number;
  inactive: boolean;
  opponent?: Nullable<PlayerLiteDTO>;
  blockedPlayerDueRevengeBan?: Nullable<PlayerLiteDTO>;
}

export interface PlayerLiteDTO {
  id: string;
  name: string;
  ranking: number;
  inactive: boolean;
}

export interface PublicTenantResponse {
  players: PlayerDTO[];
  openGames: GameDTO[];
  results: GameDTO[];
  tenantName: string;
}

export interface PushSubscriptionDTO {
  tenantKey: string;
  playerId: string;
  deviceToken: string;
  platform: PlatformType;
  createdAt: Date;
}

export interface PushSubscriptionRequest {
  deviceToken: string;
  platform: PlatformType;
  playerId: string;
}

export interface RankingChangeRequest {
  playerId: string;
  newRanking: number;
}

export interface TenantDTO {
  id: string;
  tenantKey: string;
  name: string;
  cupPassword: string;
  startTimestamp: Date;
  status: Status;
  accessGranted: boolean;
  createdAt: Date;
}

export interface TenantLoginRequest {
  tenantKeyOrTenantName: string;
  cupPassword: string;
}

export interface TenantUpdateRequest {
  cupPassword?: Nullable<string>;
  startTimestamp?: Nullable<Date>;
}

export interface TimelineItemDTO {
  id: string;
  occurredAt: string;
  type: TimelineEventType;
  message: string;
  relatedPlayerIds: string[];
  relatedGameId?: Nullable<string>;
  extra: { [index: string]: string };
}

export interface Companion {}

export interface UpdateGameDetailsRequest {
  gameId: string;
  expectedStartTimestamp?: Nullable<Date>;
  location?: Nullable<string>;
  spectatorsAllowed?: Nullable<boolean>;
  additionalComments?: Nullable<string>;
}

export interface UpdatePlayerRequest {
  id: string;
  name: string;
  ranking: number;
  inactive: boolean;
}

export interface Unit {}

export interface HttpClient {
  request<R>(requestConfig: {
    method: string;
    url: string;
    queryParams?: any;
    data?: any;
    copyFn?: (data: R) => R;
  }): RestResponse<R>;
}

export class RestApplicationClient {
  constructor(protected httpClient: HttpClient) {}

  /**
   * HTTP GET /api/v2/configuration
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.ConfigurationController.getConfiguration
   */
  getConfiguration(): RestResponse<ConfigurationDTO> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`api/v2/configuration` });
  }

  /**
   * HTTP PUT /api/v2/configuration
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.ConfigurationController.updateConfiguration
   */
  updateConfiguration(configurationDTO: ConfigurationDTO): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`api/v2/configuration`, data: configurationDTO });
  }

  /**
   * HTTP POST /api/v2/games
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.GameController.createGame
   */
  createGame(request: CreateGameRequest): RestResponse<GameDTO> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`api/v2/games`, data: request });
  }

  /**
   * HTTP GET /api/v2/games
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.GameController.loadGames
   */
  loadGames(queryParams: { open: boolean }): RestResponse<GameDTO[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`api/v2/games`, queryParams: queryParams });
  }

  /**
   * HTTP PUT /api/v2/games/details
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.GameController.updateGameDetails
   */
  updateGameDetails(request: UpdateGameDetailsRequest): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`api/v2/games/details`, data: request });
  }

  /**
   * HTTP PUT /api/v2/games/finish
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.GameController.finishGame
   */
  finishGame(request: FinishGameRequest): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`api/v2/games/finish`, data: request });
  }

  /**
   * HTTP DELETE /api/v2/games/{gameId}
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.GameController.deleteGame
   */
  deleteGame(gameId: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`api/v2/games/${gameId}` });
  }

  /**
   * HTTP GET /api/v2/operator
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.OperatorController.getOperatorData
   */
  getOperatorData(): RestResponse<OperatorDataDTO> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`api/v2/operator` });
  }

  /**
   * HTTP POST /api/v2/players
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PlayerController.createPlayer
   */
  createPlayer(createPlayerRequest: CreatePlayerRequest): RestResponse<PlayerLiteDTO> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`api/v2/players`, data: createPlayerRequest });
  }

  /**
   * HTTP GET /api/v2/players
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PlayerController.getAllPlayers
   */
  getAllPlayers(): RestResponse<PlayerDTO[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`api/v2/players` });
  }

  /**
   * HTTP PUT /api/v2/players
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PlayerController.updatePlayer
   */
  updatePlayer(request: UpdatePlayerRequest): RestResponse<PlayerLiteDTO> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`api/v2/players`, data: request });
  }

  /**
   * HTTP GET /api/v2/players/lite
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PlayerController.getAllPlayersLite
   */
  getAllPlayersLite(): RestResponse<PlayerLiteDTO[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`api/v2/players/lite` });
  }

  /**
   * HTTP DELETE /api/v2/players/{playerId}
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PlayerController.deletePlayer
   */
  deletePlayer(playerId: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`api/v2/players/${playerId}` });
  }

  /**
   * HTTP GET /api/v2/public/tenantinfo
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PublicController.getPublicTenantInfo
   */
  getPublicTenantInfo(queryParams: { param: string }): RestResponse<PublicTenantResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`api/v2/public/tenantinfo`,
      queryParams: queryParams,
    });
  }

  /**
   * HTTP GET /api/v2/push/subscription
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PushSubscriptionController.getPushSubscriptions
   */
  getPushSubscriptions(queryParams: { playerId: string; deviceToken?: string }): RestResponse<PushSubscriptionDTO[]> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`api/v2/push/subscription`,
      queryParams: queryParams,
    });
  }

  /**
   * HTTP POST /api/v2/push/subscription/register
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PushSubscriptionController.registerPushSubscription
   */
  registerPushSubscription(request: PushSubscriptionRequest): RestResponse<void> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`api/v2/push/subscription/register`,
      data: request,
    });
  }

  /**
   * HTTP POST /api/v2/push/subscription/unregister
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.PushSubscriptionController.unregisterPushSubscription
   */
  unregisterPushSubscription(request: PushSubscriptionRequest): RestResponse<void> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`api/v2/push/subscription/unregister`,
      data: request,
    });
  }

  /**
   * HTTP POST /api/v2/ranking
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.RankingController.createRankingChange
   */
  createRankingChange(requests: RankingChangeRequest[]): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`api/v2/ranking`, data: requests });
  }

  /**
   * HTTP GET /api/v2/tenants
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.TenantController.getTenant
   */
  getTenant(): RestResponse<TenantDTO> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`api/v2/tenants` });
  }

  /**
   * HTTP POST /api/v2/tenants/create
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.TenantController.createTenant
   */
  createTenant(request: CreateTenantRequest): RestResponse<TenantDTO> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`api/v2/tenants/create`, data: request });
  }

  /**
   * HTTP GET /api/v2/tenants/exists
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.TenantController.existsTenantByName
   */
  existsTenantByName(queryParams: { name: string }): RestResponse<Unit> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`api/v2/tenants/exists`,
      queryParams: queryParams,
    });
  }

  /**
   * HTTP POST /api/v2/tenants/login
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.TenantController.login
   */
  login(loginRequest: TenantLoginRequest): RestResponse<TenantDTO> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`api/v2/tenants/login`, data: loginRequest });
  }

  /**
   * HTTP POST /api/v2/tenants/loginAdmin
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.TenantController.loginAdmin
   */
  loginAdmin(loginRequest: AdminLoginRequest): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`api/v2/tenants/loginAdmin`, data: loginRequest });
  }

  /**
   * HTTP PUT /api/v2/tenants/update
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.TenantController.updateTenant
   */
  updateTenant(request: TenantUpdateRequest): RestResponse<void> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`api/v2/tenants/update`, data: request });
  }

  /**
   * HTTP GET /api/v2/timeline
   * Java method: com.wholegrainsoftware.pyramidcup.web.v3.controller.TimelineController.list
   */
  list(queryParams?: { page?: number; size?: number }): RestResponse<TimelineItemDTO[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`api/v2/timeline`, queryParams: queryParams });
  }
}

export type RestResponse<R> = Promise<R>;

export type Status = 'NOT_STARTED' | 'STARTED';

export type PlatformType = 'ANDROID' | 'IOS' | 'WEB';

export type TimelineEventType =
  | 'CHALLENGE_CREATED'
  | 'GAME_RESULT_ENTERED'
  | 'GAME_RESULT_EDITED'
  | 'GAME_DELETED'
  | 'PLAYER_CREATED'
  | 'PLAYER_DELETED'
  | 'PLAYER_ACTIVITY_CHANGED'
  | 'RANKING_UPDATE'
  | 'CUP_START_TIME_CHANGED'
  | 'CONFIGURATION_CHANGED'
  | 'ADMIN_MESSAGE'
  | 'SUGGESTION';

export type Nullable<T> = T | null | undefined;

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}
